/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'maintenance': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M9.145 14.004h1.975a.745.745 0 00.749-.74.745.745 0 00-.75-.741H9.146c-3.725 0-6.745 2.984-6.745 6.665v-.318c0 .41.336.741.75.741h6.542c.414 0 .75-.332.75-.74a.745.745 0 00-.75-.741H3.999l.08-.292c.6-2.209 2.641-3.834 5.066-3.834zM9.834 2.4c2.201 0 3.984 1.847 3.984 4.123 0 2.275-1.783 4.122-3.984 4.122-2.202 0-3.985-1.847-3.985-4.122C5.85 4.247 7.632 2.4 9.834 2.4zm0 1.46c-1.415 0-2.565 1.191-2.565 2.663 0 1.47 1.15 2.661 2.565 2.661s2.564-1.19 2.564-2.661c0-1.472-1.15-2.662-2.564-2.662zm9.975 10.468l-5.337 4.23-2.646-3.21a.656.656 0 00-1.141.139.685.685 0 00.079.67l3.096 3.71c.22.3.636.36.93.136l5.816-4.596a.678.678 0 00-.137-1.16.657.657 0 00-.66.08z" _fill="#1D3861" fill-rule="evenodd"/>'
  }
})
